import React from "react"
import types from "prop-types"
import { MenuButton } from "@szhsin/react-menu"
import { useDispatch } from "react-redux"
import { deleteReport } from "reduxSlices/reportIndexSlice"
import { redirectTo } from "utils/routeHelpers"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"
import clsx from "clsx"

const ReportMenu = ({ editPath, report, reportType }) => {
  const dispatch = useDispatch()

  const { editable, deletable } = report

  const hideMenu = !editable && !deletable

  const goToReportEditPage = () => redirectTo(editPath(report.id))

  const removeReport = () => {
    if (window.confirm("Are you sure you want to delete this report?")) {
      dispatch(deleteReport({ reportType, reportId: report.id }))
    }
  }

  return (
    <div className={clsx(hideMenu && "invisible pointer-events-none")}>
      <ExpandMenu
        expandMenuComponent={(
          <MenuButton className="circular-icon-button p-2.5" aria-label="show menu">
            <svg className="!w-4 !h-4" aria-hidden><use xlinkHref="#ellipsis" /></svg>
          </MenuButton>
        )}
      >
        {
          editable && (
            <ExpandMenuItem onClick={goToReportEditPage}>
              Edit
            </ExpandMenuItem>
          )
        }
        {
          deletable && (
            <ExpandMenuItem onClick={removeReport}>
              Delete
            </ExpandMenuItem>
          )
        }
      </ExpandMenu>
    </div>
  )
}

ReportMenu.propTypes = {
  report: types.objectOf(types.any).isRequired,
  reportType: types.string.isRequired,
  editPath: types.func.isRequired,
}

export default ReportMenu
